<template lang="pug">
.empty
  img(
    src="https://m.hellobike.com/resource/AppPlatformH5/bounty/O0US02pnkxlShWTWzqE7t.png"
  )
  span 敬请期待～
</template>

<script>
export default {

};
</script>

<style scoled lang="less">
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.12rem;
  color: #ccc;
  padding-bottom: 0.2rem;

  img {
    width: 0.78rem;
    height: 0.68rem;
    margin-bottom: 0.08rem;
  }
}
</style>
